import { render, staticRenderFns } from "./EditRelationDialog.vue?vue&type=template&id=1920ff53&scoped=true"
import script from "./EditRelationDialog.vue?vue&type=script&lang=js"
export * from "./EditRelationDialog.vue?vue&type=script&lang=js"
import style0 from "./EditRelationDialog.vue?vue&type=style&index=0&id=1920ff53&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1920ff53",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1920ff53')) {
      api.createRecord('1920ff53', component.options)
    } else {
      api.reload('1920ff53', component.options)
    }
    module.hot.accept("./EditRelationDialog.vue?vue&type=template&id=1920ff53&scoped=true", function () {
      api.rerender('1920ff53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rs/merchant/oneCardMerchant/components/EditRelationDialog.vue"
export default component.exports